import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import AgentWantAdForm from "../components/AgentWantAdForm";
import { AGENT_WANTAD_KEY } from "@/constants/common";
import { getWantAdById } from "@/services/v2/wantAdService";
import Loader from "../components/Common/Loader";
import _ from "lodash"

const AgentEditWantAd = () => {

  const { id } = useParams();
  const location = useLocation();

  const isFromConfirmationPage =
    location.state && location.state["isFromConfirmationPage"] ? true : false;
  const stateData = location.state?.data;

  const [wantAdData, setWantAdData] = useState(null);
  const [showPublished, setShowPublished] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (isFromConfirmationPage) {
      const localData = JSON.parse(localStorage.getItem(AGENT_WANTAD_KEY));
      setWantAdData(localData);
      setLoaded(true);
      return;
    }

    if (stateData) {
      setWantAdData(stateData);
      setLoaded(true);
      return;
    }

    getWantAdById(id)
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (response.errorCode === 0 && responseResult) {
          if (responseResult?.isPublished === 1) {
            setShowPublished(true);
          } else {
            setWantAdData(responseResult);
          }
        }
        setLoaded(true);
      })
      .catch((err) => {
        console.log("Error", err);
        setLoaded(true);
      });
  }, [id]);

  if (!loaded) {
    return <Loader />;
  }

  if (showPublished) {
    return (
      <div className="row m-0">
        <h2 className="text-center">Want-Listing already published</h2>
      </div>
    );
  }

  return <AgentWantAdForm initialData={wantAdData} isEdit={true} />;
};

export default AgentEditWantAd;
